import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

export const DISAMBIGUATED_MARKET_TIMEZONES: Partial<
  Record<MarketCountryCode, string>
> = {
  [MarketCountryCode.US]: 'America/Chicago',
  [MarketCountryCode.AU]: 'Australia/Sydney',
}
